import { createSelector } from 'reselect'
import { toPairs } from 'lodash'

export const PAX_PAYMENT_TYPE = 'pax'

export const getPeripheralConnected = (state) => state?.peripheral?.peripheralConnected ?? true

export const getPeripheralIsBusy = (state) => state?.peripheral?.peripheralIsBusy ?? false

export const getSafIsUploading = (state) => state?.peripheral?.safIsUploading ?? false

export const getSafUploadComplete = (state) => state?.peripheral?.safUploadComplete ?? false

const getInfo = (state, options = { target: '', json: true }) => {
  const targetInfoReceived = state?.peripheral?.[`${options?.target}Received`] ?? false
  const targetInfo = state?.peripheral?.[options?.target] ?? {}

  if (options?.json) return targetInfo

  let infoString = toPairs(targetInfo).map((pair) => pair.join(': ')).join(', ')

  if (targetInfoReceived && infoString !== '') {
    return infoString
  } else if (targetInfoReceived === false) {
    return 'Not Received'
  } else if (infoString === '') {
    return 'Not Found'
  }
}

export const getFirmwareInfo = (state, options = { json: true }) => {
  return getInfo(state, { target: 'firmwareInfo', ...options })
}

export const getBuildInfo = (state, options = { json: true }) => {
  return getInfo(state, { target: 'buildInfo', ...options })
}

export const getTerminalInfo = (state, options = { json: true }) => {
  return getInfo(state, { target: 'terminalInfo', ...options })
}

export const getPaymentType = (state) => {
  const buildInfo = getBuildInfo(state)

  return buildInfo?.paymentType || null
}

// We always use 'executeSaleRequest' for globalpay.
export const makeGetInitialBridgeMethod = () => createSelector(
  () => 'executeSaleRequest'
)

export const getCardReaderFailedCardCount = (state) => getSafFullResponse(state)["SAFFailedCount"] ?? 0

export const getSafFullResponse = (state) => {
  return state?.peripheral?.safFullResponse ?? {}
}
